import { render, staticRenderFns } from "./QuestionInputs.vue?vue&type=template&id=642c6fd3"
import script from "./QuestionInputs.vue?vue&type=script&lang=js"
export * from "./QuestionInputs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports